import { takeLatest, put, call, all } from "redux-saga/effects";
import GemeindeActionTypes from "./gemeinde.types";
import { firestore } from "../../utils/firebase/firebase.util";
import {
  fetchGemeindeSuccess,
  fetchErntehelferSuccess,
  fetchGemeindeFailure,
  fetchGemeindelisteSuccess,
  fetchGemeindelisteFailure,
} from "./gemeinde.actions";

export function* fetchGemeindeAsync({ payload }) {
  try {
    const snapShot = yield payload.get();
    const gemeindeData = yield snapShot.data();
    yield put(fetchGemeindeSuccess({ ...gemeindeData, id: snapShot.id }));
    yield call(fetchErntehelferAsync, payload);
  } catch (error) {
    yield put(fetchGemeindeFailure(error));
  }
}

export function* fetchErntehelferAsync(gemeindeRef) {
  try {
    const userCollection = firestore.collection("users");
    const userList = yield userCollection.where(
      "gemeindeRef",
      "==",
      gemeindeRef
    );
    const snapShot = yield userList.get();
    const erntehelfer = yield snapShot.docs.map((user) => ({
      id: user.id,
      ...user.data(),
    }));

    yield put(fetchErntehelferSuccess(erntehelfer));
  } catch (error) {
    yield put(fetchGemeindeFailure(error));
  }
}

export function* fetchGemeindelisteAsync() {
  try {
    const gemeindeCollection = firestore.collection("gemeinden");
    const snapShot = yield gemeindeCollection.get();
    const gemeindeListe = yield snapShot.docs.map((gemeinde) => ({
      id: gemeinde.id,
      ...gemeinde.data(),
    }));
    yield put(fetchGemeindelisteSuccess(gemeindeListe));
  } catch (error) {
    yield put(fetchGemeindelisteFailure(error));
  }
}

export function* onFetchGemeinde() {
  yield takeLatest(
    GemeindeActionTypes.FETCH_GEMEINDE_START,
    fetchGemeindeAsync
  );
}

export function* onFetchGemeindeliste() {
  yield takeLatest(
    GemeindeActionTypes.FETCH_GEMEINDELISTE_START,
    fetchGemeindelisteAsync
  );
}

export function* gemeindeSagas() {
  yield all([call(onFetchGemeinde), call(onFetchGemeindeliste)]);
}
